import { createSelector } from '../../dependencies';

export const selectMessages = state => state.ui.messages;

export const messagesSelector = createSelector(
    selectMessages,
    ({ byId, ids }) => ids.map(id => byId[id]),
);
